import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import EbisInterfaceMonitoringMaintenanceCont from "presentation/view/container/EbisInterfaceMonitoring/EbisInterfaceMonitoringContMain";

CommonEntrypoint(<EbisInterfaceMonitoringMaintenanceCont/>)